import { render } from "./SupplierForm.vue?vue&type=template&id=b7bc7cc8&ts=true"
import script from "./SupplierForm.vue?vue&type=script&lang=ts"
export * from "./SupplierForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__